import { gql } from '@efficiently/client-core-graphql-models';

/**
 * The Design Change cards of one scope (Project Bid) for its Scope Creep view, each card holding its
 * Design Change and its history rows, plus the total row count and whether a cap cut rows from the
 * cards.
 *
 * Guarded server-side by `ProjectBidView` and `DesignChangeView` together. The server orders the cards
 * and the rows inside each card, so the client renders them in the order received. `eventType`
 * narrows the rows to one change kind; omit it for every kind.
 */
export const PROJECT_BID_DESIGN_CHANGE_CARDS = gql(`
	query ProjectBidDesignChangeCards($projectBidId: ID!, $eventType: HistoryEventChangeType) {
		projectBidDesignChangeCards(projectBidId: $projectBidId, eventType: $eventType) {
			totalRowCount
			truncated
			cards {
				isNumberTagVisible
				designChange {
					_id
					number
					name
					description
					status
				}
				rows {
					...HistoryItemFields
				}
			}
		}
	}
`);
